var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotRespsonseStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.6665L6.32267 5.59584C5.872 6.8145 5.64667 7.42384 5.202 7.8685C4.75733 8.31317 4.148 8.5385 2.92933 8.98917L2 9.33317L2.92933 9.67717C4.148 10.1278 4.75733 10.3538 5.202 10.7978C5.64667 11.2418 5.872 11.8518 6.32267 13.0705L6.66667 13.9998L7.01067 13.0705C7.46133 11.8518 7.68733 11.2425 8.13133 10.7978C8.57533 10.3532 9.18533 10.1278 10.404 9.67717L11.3333 9.33317L10.404 8.98917C9.18533 8.5385 8.576 8.31317 8.13133 7.8685C7.68667 7.42384 7.46133 6.8145 7.01067 5.59584L6.66667 4.6665Z",
    stroke: "#6860EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L11.8527 2.398C11.6593 2.92067 11.5627 3.182 11.3727 3.372C11.182 3.56267 10.9207 3.65933 10.398 3.852L10 4L10.3987 4.14733C10.9207 4.34067 11.182 4.43733 11.372 4.62733C11.5627 4.818 11.6593 5.07933 11.852 5.602L12 6L12.1473 5.602C12.3407 5.07933 12.4373 4.818 12.6273 4.628C12.818 4.43733 13.0793 4.34067 13.602 4.148L14 4L13.6013 3.85267C13.0793 3.65933 12.818 3.56267 12.628 3.37267C12.4373 3.182 12.3407 2.92067 12.148 2.398L12 2Z",
    stroke: "#6860EE",
    strokeWidth: 0.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotRespsonseStarIcon);
export default __webpack_public_path__ + "static/media/bot-respsonse-star-icon.ce66a01d09d71e3a9b3e939ed1a157e4.svg";
export { ForwardRef as ReactComponent };